<template>
  <div>
    <template v-if="$showCommunity()">
      <header class="position-fixed top-0 bg-white w-100" :class="{'z-index-1040': backdrop_for != 'cr_lang'}">
        <div class="w-100 position-relative">
          <div class="ga-container fluid">
            <div class="row py-1">
              <div class="col-2 align-self-center py-1 cursor-pointer" @click="goToGroup()">
                <img :src="getMerchant.community.image_url" alt="Logo" class="w-auto" height="52">
              </div>
              <div class="col-8 align-self-center text-center">
                <div class="w-100 mobile-none" v-if="backdrop_for == ''">
                  <div class="d-table no-ws mx-auto pl-3 bg-white border-semi-grey rounded-4 mx-2 box-shadow-ota-2">
                    <div class="d-inline-block align-middle" @click="toggleBackdrop('merchant')">
                      <div class="d-inline-block align-middle mr-3">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178ZM9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768Z" fill="#999999"/>
                        </svg>
                      </div>
                      <p class="mb-0 body-2-4 cursor-pointer d-inline-block align-middle mw-8">{{ getMerchant.name }}</p>
                    </div>
                    <div class="d-inline-block align-middle custom-divider"></div>
                    <div class="d-inline-block align-middle" @click="toggleBackdrop('date')">
                      <div class="d-inline-block align-middle mr-3">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4109 2.76862L16.4119 3.51824C19.1665 3.73413 20.9862 5.61119 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15188 22C5.01119 22.004 3.01482 20.027 3.01087 16.8795L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50617 3.53024L7.50518 2.78061C7.5042 2.34083 7.83001 2.01 8.26444 2.01C8.69886 2.009 9.02468 2.33883 9.02567 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.999 16.4099 2.32884 16.4109 2.76862ZM4.52148 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.5877 15.6556 6.5877C15.2212 6.5887 14.8943 6.24887 14.8943 5.81909L14.8934 5.0095L9.02863 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27036 6.5967C7.83594 6.5977 7.50913 6.25887 7.50913 5.82809L7.50815 5.05847C5.58286 5.25137 4.51753 6.38281 4.52049 8.55072L4.52148 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7903 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73243 13.3933C8.72256 12.9435 8.35725 12.5937 7.91196 12.5947C7.45779 12.6147 7.10334 12.9955 7.10433 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12901 17.5132 7.10828 17.0535C7.10729 16.5937 7.46273 16.2129 7.9169 16.1929C8.3612 16.1919 8.7275 16.5417 8.73737 16.9915C8.7581 17.4513 8.40365 17.8321 7.95837 17.8521Z" fill="#999999"/>
                        </svg>
                      </div>
                      <p class="mb-0 body-2-4 cursor-pointer d-inline-block align-middle mw-8">{{ $formatDateRange(getBeFilter.date.check_in,getBeFilter.date.check_out,'YYYY-MM-DD','YYYY-MM-DD') }}</p>
                    </div>
                    <div class="d-inline-block align-middle custom-divider"></div>
                    <div class="d-inline-block align-middle" @click="toggleBackdrop('guest')">
                      <div class="d-inline-block align-middle mr-3">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z" fill="#999999"/>
                        </svg>
                      </div>
                      <p class="mb-0 body-2-4 cursor-pointer d-inline-block align-middle mw-8">{{ total_guests }}</p>
                    </div>
                    <div class="d-inline-block align-middle custom-divider mr-2"></div>
                    <div class="d-inline-block align-middle rounded-4 cursor-pointer py-2 px-3 mr-2" @click="toggleBackdrop('search-hit')" :class="getCompanyType=='COMMUNITY'?'bg-primary-ota':'bg-green'">
                      <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.0122 12.3235L14.3616 14.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-else class="w-100 mobile-none py-2">
                  <p class="heading-6-1 mb-0">{{$t('hotel.find-your-dream-stay')}}</p>
                </div>
              </div>
              <div class="col-2 align-self-center text-right py-3">
                <div v-if="false" class="mobile-none d-inline-block align-middle">
                  <div class="d-inline-block ml-4 cursor-pointer">
                    <svg width="24" height="24" class="mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM15.9698 7.99994H18.9198C17.9598 6.34994 16.4298 5.06994 14.5898 4.43994C15.1898 5.54994 15.6498 6.74994 15.9698 7.99994ZM11.9998 4.04004C12.8298 5.24004 13.4798 6.57004 13.9098 8.00004H10.0898C10.5198 6.57004 11.1698 5.24004 11.9998 4.04004ZM4 12C4 12.69 4.1 13.36 4.26 14H7.64C7.56 13.34 7.5 12.68 7.5 12C7.5 11.32 7.56 10.66 7.64 9.99997H4.26C4.1 10.64 4 11.31 4 12ZM5.08008 16.0001H8.03008C8.35008 17.2501 8.81008 18.4501 9.41008 19.5601C7.57008 18.9301 6.04008 17.6601 5.08008 16.0001ZM5.08008 7.99999H8.03008C8.35008 6.74999 8.81008 5.54999 9.41008 4.43999C7.57008 5.06999 6.04008 6.33999 5.08008 7.99999ZM11.9998 19.96C11.1698 18.76 10.5198 17.43 10.0898 16H13.9098C13.4798 17.43 12.8298 18.76 11.9998 19.96ZM9.66 14H14.34C14.43 13.34 14.5 12.68 14.5 12C14.5 11.32 14.43 10.65 14.34 9.99997H9.66C9.57 10.65 9.5 11.32 9.5 12C9.5 12.68 9.57 13.34 9.66 14ZM14.5898 19.56C15.1898 18.45 15.6498 17.25 15.9698 16H18.9198C17.9598 17.65 16.4298 18.93 14.5898 19.56ZM16.5004 12C16.5004 12.68 16.4404 13.34 16.3604 14H19.7404C19.9004 13.36 20.0004 12.69 20.0004 12C20.0004 11.31 19.9004 10.64 19.7404 10H16.3604C16.4404 10.66 16.5004 11.32 16.5004 12Z" fill="#222222" fill-opacity="0.7"/>
                    </svg>
                    <p class="mb-0 font-semibold text-16 text-color-dark d-inline-block"><span>{{$t('hotel.language')}}</span> | {{getCurrency.code}}</p>
                  </div>
                </div>
                <div class="cursor-pointer float-right" @click="toggleOtherMenu">
                  <div class="hamburger">
                    <div class="one"></div>
                    <div class="two"></div>
                    <div class="three"></div>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-2 desktop-none" v-if="false">
                <div class="w-100 bg-white border-semi-grey rounded-4 box-shadow-ota-2">
                  <div class="row no-gutters">
                    <div class="col-2 text-center">
                      <div class="py-3">
                        <svg style="top:-3px" class="position-relative" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#959DAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#959DAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div class="col-8 my-2" @click="toggleBackdrop('merchant')">
                      <p class="mb-0 text-11 font-regular color-grey-ota">{{$t('hotel.all-property')}}</p>
                      <p class="mb-0 text-14 font-bold text-semi-dark">{{ $formatDateRange(filter_result.check_in_date,filter_result.check_out_date,'YYYY-MM-DD','YYYY-MM-DD') }} <svg class="mx-1" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="2" height="2" rx="1" fill="#222"/></svg> {{ total_guests }}</p>
                    </div>
                    <div class="col-2 py-2">
                      <div class="py-2 px-3 mr-2 d-table ml-auto border-semi-grey rounded-4 bg-grey-ota cursor-pointer" @click="toggleBackdrop('destination')">
                        <svg width="18" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.94423 2.53875C4.94423 3.88065 3.83797 4.9683 2.47212 4.9683C1.10706 4.9683 0 3.88065 0 2.53875C0 1.19763 1.10706 0.109985 2.47212 0.109985C3.83797 0.109985 4.94423 1.19763 4.94423 2.53875ZM13.2944 1.47453C13.8919 1.47453 14.3775 1.95165 14.3775 2.53863C14.3775 3.1264 13.8919 3.60352 13.2944 3.60352H8.56742C7.96916 3.60352 7.48353 3.1264 7.48353 2.53863C7.48353 1.95165 7.96916 1.47453 8.56742 1.47453H13.2944ZM1.0839 9.42517H5.81087C6.40913 9.42517 6.89477 9.90229 6.89477 10.4901C6.89477 11.077 6.40913 11.5549 5.81087 11.5549H1.0839C0.485637 11.5549 0 11.077 0 10.4901C0 9.90229 0.485637 9.42517 1.0839 9.42517ZM11.9056 12.8898C13.2715 12.8898 14.3777 11.8022 14.3777 10.4611C14.3777 9.11917 13.2715 8.03153 11.9056 8.03153C10.5405 8.03153 9.43349 9.11917 9.43349 10.4611C9.43349 11.8022 10.5405 12.8898 11.9056 12.8898Z" fill="#222222"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-10 w-100 bg-white position-absolute filter-header" :class="backdrop_for != '' ? 'h-126 pb-3' : 'h-0'" style="top:74px;left:0xp;">
            <div class="w-100 bg-white">
              <div v-if="is_load" class="py-2">
                <loader /> 
              </div>
              <template v-else> 
                <div v-if="error != ''" class="row justify-content-center">
                  <div class="col-4">
                    <ErrorMessage :message="error" />
                  </div>
                </div>
                <template v-else>
                  <transition name="fade">
                    <div class="row py-1 filter-header-child" v-show="backdrop_for != ''">
                      <div class="col-12 mt-2">
                        <MerchantFilter ref="merchant_filter" :backdrop="backdrop_for" :merchant_list="merchant_list" @toggleBackdrop="toggleBackdrop" @applyFilter="applyFilter"/>
                      </div>
                    </div>
                  </transition>
                </template>
              </template>
            </div>
          </div>
        </div>
      </header>

      <popup-detail 
        direction="right" 
        :show="show_other_menu"
        :size="25"
        title="Other Menu"
        @close="toggleOtherMenu">
        <template v-slot:body>
          <div class="px-4 pb-4">
            <div class="d-block cursor-pointer py-3" @click="callClick">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Calling.png" 
                width="24"
                :alt="getMerchant.name">
                <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.call')}}</p>
            </div>
            <router-link :to="'/'+getMerchant.code+'/feedback'" class="d-block py-3" @click.native="$trackHomeClick('NAVBAR','Clicked menu review')">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Star.png" 
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.review')}}</p>
            </router-link>
            <router-link :to="'/'+getMerchant.code+'/gallery'" class="d-block py-3" @click.native="$trackHomeClick('NAVBAR','Clicked menu gallery')">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Image.png" 
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.gallery')}}</p>
            </router-link>
            <div class="d-block py-3 cursor-pointer" @click="shareClick()">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Send.png" 
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.share')}}</p>
            </div>
            <div v-if="!isLoggedIn" class="d-block cursor-pointer py-3" @click="$openAuthModal({ view: 'login' })">
              <img
                src="../../../../assets/img/icon/menu-navbar/Login.png"
                width="24"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('profile.login.login')}}</p>
            </div>
            <div class="mb-4 mt-3">
              <router-link :to="'/'+getMerchant.code+'/account'" v-if="isLoggedIn">
                <div class="my-auto text-center box-nav-desktop p-0 d-inline-block cursor-pointer" >
                  <img :src="getCurrentUser.avatar" :alt="getMerchant.name" class="w-100 rounded-100 top-0 left-0 object-fit border-2-green" height="50" style="padding:1px">
                </div>
                <p class="mb-0 body-1-2 d-inline-block ml-1 width-profile-name text-truncate text-left">{{getCurrentUser.first_name}} {{getCurrentUser.last_name}}</p>
              </router-link>
            </div>
            <template>
              <router-link :to="'/'+getMerchant.code+'/booking'" class="d-block my-3" v-if="Object.keys(getRoomStay).length == 0 && getMerchant.use_booking_engine">
                <button type="button" class="g-btn g-btn-primary g-btn-lg px-5">{{$t('hotel.action.book-now')}}</button>
              </router-link>
            </template>
          </div>
          <div class="mt-5 px-4 text-center">
            <p class="mb-2 font-semibold text-16 text-color-dark">{{getMerchant.address}}</p>
            <p class="mb-2 font-semibold text-16 text-color-dark">
              <a :href="'tel:'+getMerchant.phone" target="_blank" class="color-black">
                <u>{{getMerchant.phone}}</u>
              </a>
            </p>
            <p class="mb-2 font-semibold text-16 text-color-dark">
              <a :href="'mailto:'+getMerchant.email" target="_blank" class="color-black">
                <u>{{getMerchant.email}}</u>
              </a>
            </p>
            <template>
              <div class="mt-4">
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.whatsapp_number != '' && getMerchant.whatsapp_number != null">
                  <a :href="'https://api.whatsapp.com/send/?phone='+maskingPlusChar(getMerchant.whatsapp_number)+'&text&app_absent=0'" target="_blank">
                    <img src="../../../../assets/img/icon/social/whatsapp.svg" class="cursor-pointer social-img" width="35" title="Whatsapp">
                    <img src="../../../../assets/img/icon/social/blur/whatsapp.svg" class="cursor-pointer social-img-blur" width="35" title="Whatsapp">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.facebook_link != '' && getMerchant.facebook_link != null">
                  <a :href="getMerchant.facebook_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/facebook.svg" class="cursor-pointer social-img" width="35" title="Facebook">
                    <img src="../../../../assets/img/icon/social/blur/facebook.svg" class="cursor-pointer social-img-blur" width="35" title="Facebook">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.instagram_link != '' && getMerchant.instagram_link != null">
                  <a :href="getMerchant.instagram_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/instagram.svg" class="cursor-pointer social-img" width="35" title="Instagram">
                    <img src="../../../../assets/img/icon/social/blur/instagram.svg" class="cursor-pointer social-img-blur" width="35" title="Instagram">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tiktok_link != '' && getMerchant.tiktok_link != null">
                  <a :href="getMerchant.tiktok_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
                    <img src="../../../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tripadvisor_link != '' && getMerchant.tripadvisor_link != null">
                  <a :href="getMerchant.tripadvisor_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/tripadvisor.svg" class="cursor-pointer social-img" width="35" title="Tripadvisor">
                    <img src="../../../../assets/img/icon/social/blur/tripadvisor.svg" class="cursor-pointer social-img-blur" width="35" title="Tripadvisor">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.youtube_link != '' && getMerchant.youtube_link != null">
                  <a :href="getMerchant.youtube_link" target="_blank">
                    <img src="../../../../assets/img/icon/social/youtube.svg" class="cursor-pointer social-img" width="35" title="Youtube">
                    <img src="../../../../assets/img/icon/social/blur/youtube.svg" class="cursor-pointer social-img-blur" width="35" title="Youtube">
                  </a> 
                </div>
                <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.website != '' && getMerchant.website != null">
                  <a :href="getMerchant.website" target="_blank">
                    <img src="../../../../assets/img/icon/social/website.svg" class="cursor-pointer social-img" width="35" title="Website">
                     <img src="../../../../assets/img/icon/social/blur/website.svg" class="cursor-pointer social-img-blur" width="35" title="Website">
                  </a> 
                </div>
              </div>
            </template>
          </div>
        </template>
      </popup-detail>

      <transition name="fade">
        <template v-if="backdrop_for != ''">
          <PopUpBackground 
            @handlePopupFilter="toggleBackdrop"></PopUpBackground>
        </template>
      </transition>
    </template>
    <template v-else>
      <!-- NAVBAR -->
      <header class="position-fixed top-0 bg-white w-100 z-index-1040 d-flex align-items-center" style="height:82.4px">
        <div class="ga-container fluid d-flex align-items-center justify-content-between">
          <img :src="getMerchant.image_url" width="70" :alt="getMerchant.name">
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center cursor-pointer" @click="callClick">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Calling.png" 
                width="20"
                :alt="getMerchant.name">
                <p class="mb-0 body-1-2 ml-2">{{$t('restaurant.menu.call')}}</p>
            </div>
            <router-link :to="'/'+getMerchant.code+'/feedback'" class="ml-xl-4 ml-md-3 d-flex align-items-center" @click.native="$trackHomeClick('NAVBAR','Clicked menu review')">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Star.png" 
                width="20"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 ml-2">{{$t('restaurant.menu.review')}}</p>
            </router-link>
            <router-link v-if="totalGallery > 0" :to="'/'+getMerchant.code+'/gallery'" class="ml-xl-4 ml-md-3 d-flex align-items-center" @click.native="$trackHomeClick('NAVBAR','Clicked menu gallery')">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Image.png" 
                width="20"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 ml-2">{{$t('restaurant.menu.gallery')}}</p>
            </router-link>
            <div class="ml-xl-4 ml-md-3 d-flex align-items-center cursor-pointer" @click="shareClick()">
              <img 
                src="../../../../assets/img/icon/menu-navbar/Send.png" 
                width="20"
                :alt="getMerchant.name">
              <p class="mb-0 body-1-2 ml-2">{{$t('restaurant.menu.share')}}</p>
            </div>
            <div class="ml-xl-4 ml-md-3" v-if="getMerchant.use_user_menu">
              <template v-if="$useCommunityAuth()">
                <div v-if="!isLoggedIn" @click="$loginWithCommunity()" class="d-flex align-items-center">
                  <img 
                    src="../../../../assets/img/icon/menu-navbar/Login.png" 
                    width="20"
                    :alt="getMerchant.name">
                  <p class="mb-0 body-1-2 ml-2">{{$t('profile.login.login')}}</p>
                </div>
                <userDropdownMenu v-else />
              </template>
              <template v-else>
                <div v-if="!isLoggedIn" class="d-flex align-items-center cursor-pointer" @click="$openAuthModal({ view: 'login' })">
                  <img
                    src="../../../../assets/img/icon/menu-navbar/Login.png"
                    width="20"
                    :alt="getMerchant.name">
                  <p class="mb-0 body-1-2 ml-2">{{$t('profile.login.login')}}</p>
                </div>
                <router-link :to="'/'+getMerchant.code+'/account'" class="d-flex align-items-center" v-if="isLoggedIn" tag="a">
                  <div style="height: 30px;width:30px;" class="border-semi-grey rounded-circle overflow-hidden">
                    <img :src="getCurrentUser.avatar" :alt="getCurrentUser.first_name" class="img-fit">
                  </div>
                  <p class="mb-0 body-1-2 ml-2 text-truncate text-left" style="max-width: 130px;">{{getCurrentUser.first_name}}</p>
                </router-link>
              </template>
            </div>
            <button v-if="show_booking_engine_section" type="button" class="g-btn g-btn-primary g-btn-lg px-xl-4 px-md-3 ml-xl-4 ml-md-3" @click="goToBookingPage">{{$t('hotel.action.book-now')}}</button>
          </div>
        </div>
      </header>
      <div style="height: 85px;" v-if="$route.name == 'HomePage'"></div>
    </template>
  </div>
</template>
<script>
  import { mapGetters,mapMutations } from 'vuex';
  import { get } from '@/services/index.js'
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  import MerchantFilter from '@/components/community/Filter'
  import moment from 'moment'
  import userDropdownMenu from './userDropdownMenu.vue';

  export default{
    props: {
      useCustomBookingParams: {
        type: Boolean,
        default: false
      }
    },
    components:{
      PopUpBackground,
      MerchantFilter,
      userDropdownMenu
    },
    data(){
      return{
        is_load: false,
				error: '',
				scrollPosition: null,
				merchant_list: [],
        backdrop_for: '',
        filter_result: {},
        show_other_menu: false,
        totalGallery: 0
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getBeFilter','getCurrency','getCompanyType','isNotLogin','getRoomStay','getCurrentUser','isLoggedIn','isReservationActive']),
      show_booking_engine_section(){
				if(this.isReservationActive || !this.getMerchant.use_booking_engine) return false
				else return true
			},
      total_guests(){
				let total_guest = Number(this.getBeFilter.guest.adult)+Number(this.getBeFilter.guest.child)
				return `${total_guest} ${this.$pluralWord(total_guest,'Guest')}`
			},
      show_filter_top(){
        return false
      }
    },
    watch:{
			scrollPosition(){
				this.toggleBackdrop()
			}
		},
    mounted(){
      window.addEventListener('scroll', this.updateScroll);
      this.loadFirstData()
    },
    methods:{
      ...mapMutations(['resetBeFilter','setBeFilter']),
      updateScroll() {
				this.scrollPosition = window.scrollY
			},
      toggleBackdrop(data=''){
				this.backdrop_for = data
	    },
      loadFirstData(){
        this.is_load = true
        this.error = ''
        this.loadGelleryData();
        if(this.$showCommunity()){
          this.loadMerchantList().catch(err=>this.error = err).finally(()=>this.is_load=false)
        }
      },
      loadMerchantList(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY','merchant-list',{
      			community_id: this.getMerchant.community.id,
      			merchant_type:  'hotel'
      		}).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.merchant_list = res.data
              this.merchant_list.unshift({
                name: 'All Property',
                id: 'all'
              })
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
      async loadGelleryData(){
        try {
          const apiRespone = await get("CORE_HOTEL", `v2/merchant-gallery/${this.getMerchant.id}`);
          const { success, data, message } = apiRespone.data; 
          if(!success) throw new Error(message);
          this.totalGallery = data.length;
        } catch (error) {
          console.log("ERROR : ", error.message)
        }
      },
      customFormatDate(date,format){
				return moment(date).format(format)
			},
      applyFilter(data){
        this.filter_result = {
          check_in_date: this.customFormatDate(data.date.startDate,'YYYY-MM-DD'),
          check_out_date: this.customFormatDate(data.date.endDate,'YYYY-MM-DD'),
          promo_code: data.promo_code,
          adult: data.guest.adult,
          child: data.guest.child,
          infant: data.guest.infant
        }
        if((data.merchant.id && data.merchant.id == 'all') || !data.merchant.id){
          this.goToGroup()
        }else{
          if(data.merchant.id != this.getMerchant.id){
            let params = `hotel-filter-redirect/${this.filter_result.check_in_date}/${this.filter_result.check_out_date}`
            if(this.filter_result.promo_code != ''){
              params += `/${this.filter_result.promo_code}`
            }else{
              params += '/promo_code_empty'
            }
            params += `?guest=${this.filter_result.adult}-${this.filter_result.child}-${this.filter_result.infant}`
            let merchant_url = `${window.location.origin}/${data.merchant.code}/${params}`
            window.open(merchant_url,'_self')
          }else{
            let params = {
              date: {
                check_in: data.date.startDate,
                check_out: data.date.endDate,
              },
              guest: data.guest,
              promo_code: data.promo_code,
            }
            this.setBeFilter(params)
            this.$router.push(`/${this.getMerchant.code}/booking`)
          }
        }
      },
      goToGroup(){
        let community_url = `${window.location.origin}/${this.getMerchant.community.code}/group`
        window.open(community_url,'_self')
      },
      toggleOtherMenu(){
        this.show_other_menu = !this.show_other_menu
      },
      shareClick(){
        this.$emit("shareClick")
      },
      callClick(){
				this.$emit('callClick')
			},
      goToBookingPage(){
        if(this.useCustomBookingParams) this.$emit('goToBookingPage')
        else this.goToBookingPage();
      },
      maskingPlusChar(data){
        let return_data = data.substring(0,1)
        return return_data == '+' ? data.substring(1,data.length) : data
      },
      formatCustomDate(data, frmt) {
        return moment(data).format(frmt);
      },
      goToSearchRoom() {
        this.$trackHomeClick('PREVIEW BOOK ROOM', 'Clicked book now');
        this.$router.push(`/${this.getMerchant.code}/booking`);
      },
      goToBookingPage(){
      	return new Promise((success,fail)=>{
          const today = moment();
          const nextDay = moment().add(1, 'd');

      		let use_other_booking_engine = this.getMerchant.use_custom_booking_engine_landing_page
      		if(use_other_booking_engine){
      			let parsed_url = this.getMerchant.custom_booking_engine_landing_page_url
      			let params = [
	  					{ name: "Checkin Date (DD)", parameter: "{{checkin_date}}", value: this.formatCustomDate(today,'DD') },
						  { name: "Checkin Month (MM)", parameter: "{{checkin_month}}", value: this.formatCustomDate(today,'MM') },
						  { name: "Checkin Year (YYYY)", parameter: "{{checkin_year}}", value: this.formatCustomDate(today,'YYYY') },
						  { name: "Checkout Date (DD)", parameter: "{{checkout_date}}", value: this.formatCustomDate(nextDay,'DD') },
						  { name: "Checkout Month (MM)", parameter: "{{checkout_month}}", value: this.formatCustomDate(nextDay,'MM') },
						  { name: "Checkout Year (YYYY)", parameter: "{{checkout_year}}", value: this.formatCustomDate(nextDay,'YYYY') },
						  { name: "Total Night Stay", parameter: "{{total_night}}", value: 2 },
						  { name: "Total Adult", parameter: "{{total_adult}}", value: 2 },
						  { name: "Total Child", parameter: "{{total_child}}", value: 0 },
						  { name: "Total Infant", parameter: "{{total_infant}}", value: 0 },
						  { name: "Total Guest", parameter: "{{total_guest}}", value: 2 },
						  { name: "Currency in ISO format", parameter: "{{currency_code}}", value: this.getMerchant.base_currency_code },
						  { name: "Language Used", parameter: "{{langugae_code}}", value: 'en' },
						  { name: "Promo Code", parameter: "{{promo_code}}", value: "" },
						]
      			params.forEach(item=>{
			        parsed_url = parsed_url.replaceAll(item.parameter,item.value)
			      })
      			this.$openLink(parsed_url,'_blank')
      			success()
      		}else{
	      		setTimeout(()=>{
	      			let params = {
	      				date: {
		        			check_in: today,
		        			check_out: nextDay
		        		},
		        		guest: { adult: 2, child: 0, infant: 0 },
		        		promo_code: ""
	      			}
	      			this.setBeFilter(params)
	      			this.goToSearchRoom()
	      			success()
	      		},300)
      		}
      	})
      },
    }
  }
</script>
<style scoped>
	.custom-divider{
		height: 50px;
		width: 1px;
		margin: 0px 18px;
		background-color: #DDDDDD;
	}
	.filter-header{
		transition: 0.3s ease-in-out;
	}
	.filter-header-child{
		transition: 0.6s ease-in-out;
	}
	.h-0{
		height: 0px;
		overflow: hidden;
	}
	.h-126{
		height: 126px;
	}
	.mw-80{
		max-width: 80%;
	}
  @media screen and (min-width: 1200px) {
    .custom-margin-right{
      margin-right: 32px;
      margin-top: -4px;
    }
  }
  @media screen and (max-width: 1199px) {
    .custom-margin-right{
      margin-right: 16px;
      margin-top: -4px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/HomeNavbar.vue